import React from 'react'
import { Drawer } from 'antd';
import CreatePromoForm from './CreatePromoForm';
import { EditOutlined } from '@ant-design/icons';

function CreatePromo({record}) {
  const [open, setOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const showDrawer = () => {
    setEditData(record);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setEditData(null);
  };

  return (
    <>
      <EditOutlined 
        className="text-primary text-xl cursor-pointer" 
        onClick={showDrawer}
      />
      
      <Drawer
        width={window.innerWidth <= 768 ? "100%" : "40%"}
        title="Update Promocode"
        placement="right"
        onClose={onClose}
        open={open}
      >
        {editData && (
          <CreatePromoForm editData={editData} onClose={onClose} />
        )}
      </Drawer>
    </>
  );
}

export default CreatePromo;
